import { AlertState } from "../../type/alert-state";

export const clearAlertDispatch = (state: AlertState) => {
  state.allAlerts.schedulesNotStarted = [];
  state.allAlerts.deliveryGroupsExpectedToBeDelayed = [];
  state.allAlerts.deliveryGroupsCompletedWithDelay = [];
  state.allAlerts.deliveryGroupsCompletedWithoutImage = [];
};
